import type { ComponentType } from "react";
import { LayoutDashboard, PiggyBank, Wallet2, ClipboardList, CreditCard, User } from "lucide-react";

type SidebarItem = {
  label: string;
  to: string;
  icon: ComponentType<{ className?: string }>;
};

export const sidebarItems: SidebarItem[] = [
  {
    label: "Painel de Controle",
    to: "/",
    icon: LayoutDashboard,
  },
  {
    label: "Transações",
    to: "/transactions",
    icon: Wallet2,
  },
  {
    label: "Orçamentos",
    to: "/budgets",
    icon: PiggyBank,
  },
  {
    label: "Recebíveis",
    to: "/recebiveis",
    icon: ClipboardList,
  },
  {
    label: "Contas a Pagar",
    to: "/contaspagar",
    icon: CreditCard,
  },
  {
    label: "Meu Perfil",
    to: "/profile",
    icon: User,
  },
];
